<template>
  <div style="margin-top: 71px;">
    <div>
      <div v-show="bgUrl != null && bgUrl !== ''" class="page-start" :style="{ backgroundImage:'url('+bgUrl+')'}">
      </div>
      <div v-show="bgUrl == null" class="page-start">
      </div>
      <div class="wrap">
        <my-breadcrumb :id="id"></my-breadcrumb>

        <div style="padding: 50px 0">
        <h1 class="wrap-title">{{ title }}</h1>
        </div>

        <tiny-tabs
            v-model="activeName"
            tab-style="card"
            position="left"
            :tooltip-config="{ effect: 'light', placement: 'left', visible: 'auto' }"
            style="padding-bottom: 20px;"
        >
          <tiny-tab-item v-for="item in list" :key="item.id" :title="item.name" :name="item.id + ''">

            <template>
              <div v-if="item.siteMenuDetail != null" class="box-wrapper">
                <div class="box-right">
                  <div class="box-right-title">
                    {{ item.siteMenuDetail.title }}
                  </div>
                  <div class="box-right-sub-title">
                    {{ item.siteMenuDetail.subTitle }}
                  </div>
                </div>
                <div class="box-left">
                  <img v-if="item.siteMenuDetail.imgUrls" :src="item.siteMenuDetail.imgUrls.split(',')[0]">
                </div>
              </div>

              <div v-if="item.siteMenuDetail != null && item.siteMenuDetail.videos" class="box-detail">
                <Videoplayer :mp4Url="require(item.siteMenuDetail.videos)"></Videoplayer>
              </div>

              <div v-if="item.siteMenuDetail != null" class="box-detail" v-html="item.siteMenuDetail.detail">
              </div>
            </template>

          </tiny-tab-item>
        </tiny-tabs>



      </div>
    </div>

  </div>
</template>

<script>
import {Layout as TinyLayout, Row as TinyRow, Col as TinyCol, Image, Button, Breadcrumb, BreadcrumbItem,Tabs, TabItem} from '@opentiny/vue'
import MyBreadcrumb from "@/components/MyBreadcrumb.vue";
import request from "@/utils/request";
import Videoplayer from "@/components/Video";

export default {
  name: "Template7",
  components: {
    Videoplayer,
    MyBreadcrumb,
    TinyLayout,
    TinyRow,
    TinyCol,
    TinyImage: Image,
    TinyButton: Button,
    TinyBreadcrumb: Breadcrumb,
    TinyBreadcrumbItem: BreadcrumbItem,
    TinyTabs: Tabs,
    TinyTabItem: TabItem
  },
  data() {
    return {
      activeName: '',
      needPosition: false,
      title: '',
      list: [],
      bgUrl: '',

      id: '',
      breadcrumbs: [],
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function(to, from) {
        this.init(to.query.id.toString());
      }
    }
  },
  created() {

  },
  computed: {},
  mounted() {

  },
  methods: {
    init(id){
      this.id = id;
      this.queryTemplate7();
    },

    async queryTemplate7() {
      const {data} = await request.get("/outSiteMenu/queryTemplate7/" + this.id)
      console.log(data);
      if (data.code === 200 && data.data) {
        this.list = data.data.list;
        this.bgUrl = data.data.bgUrl;
        this.title = data.data.title;
        this.needPosition = data.data.needPosition;
        // TODO 查询玩数据后进行赋值
        if (this.needPosition) {
          this.activeName = this.id + '';
        }else{
          this.activeName = this.list[0].id + '';
        }
      }
    },

    handleRoute(row){
      if(row.jump === '4' || row.jump === '5'){
        window.open(row.path, '_blank');
        return;
      }
      this.$router.push({path: '/page' + row.jump , query: {id: row.id}});
    },
  }
};
</script>

<style scoped>

.wrap{
  max-width: 1180px;
  text-align: center;
  min-height: 300px;
  margin: 0 auto;
}

.tmb-wrapper {
  margin: 100px auto 20px;
  line-height: 2rem;
}


.wrap-title {
  position: relative;
  display: inline-block;
  margin: 0 auto 20px;
  line-height: 30px;
  padding: 0 30px;
  font-weight: 400;
  font-size: 28px;
}

.wrap-title::before {
  content: "";
  width: 66px;
  height: 13px;
  background: url(../assets/images/n1_r.png) no-repeat center;
  background-size: contain;
  position: absolute;
  top: 5px;
  left: 100%;
}

.wrap-title::after {
  content: "";
  width: 66px;
  height: 13px;
  background: url(../assets/images/n1_l.png) no-repeat center;
  background-size: contain;
  position: absolute;
  top: 5px;
  right: 100%;
}

.page-start{
  background: url(~@/assets/images/about-us-start.jpg) no-repeat center;
  background-size: 100% 100%  ;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  aspect-ratio: 4.8;
}

.wrap >>> .tiny-tabs__content{
  padding-top: 0!important;
}

.box-wrapper{
  height: 150px;
  margin-bottom: 20px;
  display: flex;
  text-align: left;
  cursor: pointer;
  position: relative;
}

.box-left{
  height: 150px;
  width: 266px;
  overflow: hidden;
}

.box-left img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.box-right{
  flex: 1;
  padding: 20px;
}

.box-right-title{
  font-size: 16px;
  font-weight: bold;
  color: #214b85;
}

.box-right-sub-title{
  font-size: 14px;
  color: #9c9c9c;
  line-height: 2rem;
  max-height: 90px;
  overflow: hidden;
}

.box-wrapper img{
  transition: all 0.38s ease-in-out;
  transform: scale(1.0);
}

.box-wrapper:hover img{
  transform: scale(1.1);
}


.box-detail{
  padding: 20px;
  line-height: 2rem;
  text-align: initial;
}

.box-detail >>> img{
  max-width: 100%!important;
}


</style>
